export default __webpack_public_path__ + "static/media/f_wdt_c_6.dd07e279.mp3";